<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-user-times"></i> Motivo - Board</h3>
      </div>
    </div>
    <ReasonAdd v-if="showAdd" ref="ReasonAdd" v-on:Back="onBack" />
    <ReasonList v-else ref="ReasonList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import ReasonAdd from './components/add/reasonadd.vue'
import ReasonList from './components/list/reasonlist.vue'

export default {
  name: 'ReasonLoss',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ReasonAdd,
    ReasonList
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ReasonAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.ReasonList.onLoad()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/board/reason/reason.vue